import type { SiteConfig, TrustLogo } from '../../../siteContentTypes.ts';
import { TextField, ImageField, ToggleField, ListEditor } from './fields.tsx';

export function TrustLogosSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const t = config.trustLogos;
  const set = (patch: Partial<SiteConfig['trustLogos']>) => update({ trustLogos: { ...t, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Logos / partenaires</h2>
      <div className="error-banner" style={{ marginBottom: 16 }}>
        Rappel : tant que ce sont des logos de démonstration, gardez le titre explicite ("exemples") — ne présentez jamais un logo fictif comme un vrai partenaire.
      </div>
      <TextField label="Titre de la section" value={t.title} onChange={(v) => set({ title: v })} />
      <ListEditor<TrustLogo>
        items={t.logos}
        onChange={(logos) => set({ logos })}
        itemLabel="un logo"
        newItem={() => ({ name: 'Nouveau logo', imageUrl: '', url: '', order: t.logos.length, visible: true })}
        renderItem={(logo, patch) => (
          <>
            <TextField label="Nom" value={logo.name} onChange={(v) => patch({ name: v })} />
            <ImageField label="Image" value={logo.imageUrl} onChange={(v) => patch({ imageUrl: v })} />
            <TextField label="Lien (optionnel)" value={logo.url} onChange={(v) => patch({ url: v })} />
            <ToggleField label="Visible" value={logo.visible} onChange={(v) => patch({ visible: v })} />
          </>
        )}
      />
    </div>
  );
}
